// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"290":"Infrastructure","539":"Blog"}[chunkId] || chunkId) + "." + {"290":"293489e3","536":"355ac3f5","539":"d9f1cbd0"}[chunkId] + ".chunk.js";
};